import { createAction, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { CoreMsgTypes, FirmRecord } from '@tassat/fred-definitions';

export interface FirmState {
    [key: string]: FirmRecord;
}

const initialState: FirmState = {};

const initialLoad = createAction<{ firms: FirmState }>('InitialLoad');
const newACGMapping = createAction<{ firms: FirmState }>('NewACGMapping');
const firmRecord = createAction<FirmRecord>(CoreMsgTypes.FirmRecord);

const firmsSlice = createSlice({
    name: 'firms',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(firmRecord, (state, action) => {
            state[action.payload.FirmId] = action.payload;
        })
            .addMatcher(isAnyOf(initialLoad, newACGMapping),
                (state, action) => {
                    return {
                        ...state,
                        ...action.payload.firms
                    };
                })
            .addDefaultCase(state => state);
    }
});

export default firmsSlice.reducer;